/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL21vZHVsZXMvZGFzaGJvYXJkL3F1aXovcXVlc3Rpb25zL3F1ZXN0aW9ucy1zaG93LWltYWdlL3F1ZXN0aW9ucy1zaG93LWltYWdlLmNvbXBvbmVudC5zY3NzIn0= */"];
export { styles as styles };
